export class AuthLoginRequest {
  usr!: string;
  password!: string;
}
